import { render, staticRenderFns } from "./PurchaseCertificate.vue?vue&type=template&id=4a3a2374&scoped=true"
import script from "./PurchaseCertificate.vue?vue&type=script&lang=js"
export * from "./PurchaseCertificate.vue?vue&type=script&lang=js"
import style0 from "./PurchaseCertificate.vue?vue&type=style&index=0&id=4a3a2374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3a2374",
  null
  
)

export default component.exports